import React from "react";

import { CLIENT_TYPE_OPTIONS } from "../utils/clientCorrespondenceTypes.js";

export default function DataManagerClientTypeFilter({ value, counts, onChange, disabled = false }) {
  return <div data-client-type-filter className="mb-2 flex flex-wrap items-center gap-2">
    <label className="flex items-center gap-2 text-xs font-semibold text-slate-700">
      Type
      <select
        className="h-6 rounded-[4px] border border-slate-300 bg-white px-2 py-0 text-xs font-normal text-slate-700 focus-visible:outline-accent disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-400"
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
        value={value}
      >
        {CLIENT_TYPE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>{`${option.label} (${counts?.[option.value] ?? 0})`}</option>
        ))}
      </select>
    </label>
  </div>;
}
